import CachedIcon from '@mui/icons-material/Cached'
import { Box, Button, styled } from '@mui/material'
import { ElementType, FC, SyntheticEvent, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const MainContainer = styled(Box)`
  background-color: #00000043;
  height: 100%;
  width: 100%;
`

const ChangeButton = styled(Button)<{ component: ElementType }>`
  background-color: #00000043;
  border-radius: 4px;
  border: 4px solid #3a3d52;
  bottom: 25%;
  color: white;
  font-size: 16px;
  left: 50%;
  padding: 4px 40px;
  position: absolute;
  text-transform: none;
  transform: translateX(-50%);
`

const StyledCachedIcon = styled(CachedIcon)`
  position: absolute;
  color: white;
  font-size: 100px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
`

const StarDetailCardHoverEffect: FC<Props> = (props: Props) => {
  const { className, ...rest } = props

  const { t } = useTranslation()

  const handleOnMouseDown = useCallback((event: SyntheticEvent) => {
    event.stopPropagation()
  }, [])

  return (
    <MainContainer className={className} {...rest}>
      <StyledCachedIcon />
      <ChangeButton onMouseDown={handleOnMouseDown} component='div'>
        {t('common.button.change')}
      </ChangeButton>
    </MainContainer>
  )
}

type Props = {
  className?: string
}

export default StarDetailCardHoverEffect
